import React, { createContext, useContext, useEffect, useMemo, useState } from "react";
import { EventEmitter } from "events";
import BackendConfig from "src/backendConfig";

export const eventEmitter = new EventEmitter();

export function paymentComplete(Data)
{
  if (Data.Ok)
  {
    window.location.href = "paymentPage?Success=true" + "&Amount=" + encodeURIComponent(Data.Amount) + "&Currency=" + encodeURIComponent(Data.Currency) + "&Context=" + encodeURIComponent(Data.Context);
  } else
  {
    window.location.href = "paymentPage?Success=false" + "&Error=" + encodeURIComponent(Data.Error) + "&Context=" + encodeURIComponent(Data.Context);
  }
}

export function signStatus(signed)
{

  if (signed)
  {
    signedStatus = signed;
    eventEmitter.emit('statusChanged', signedStatus);
  } else
  {
    signedStatus = false;
  }
}

function CheckEvents(TabID)
{
  try
  {
    if ("WebSocket" in window)
    {
      CheckEventsWS(TabID);
      return;
    }
  }
  catch (e)
  {
    // Try fallback mechanism
  }

  CheckEventsXHTTP(TabID);
}

export function printthing(thing)
{
  console.log("the here: " + thing);
}

function CheckEventsWS(TabID)
{
  var Location = window.location;
  var Uri;

  if (Location.protocol === "https:")
    Uri = "wss:";
  else
    Uri = "ws:";

  const eventHost = process.env.REACT_APP_USE_LOCAL_API_PROXY === "true"
    ? Location.host
    : BackendConfig.neuronDomain;
  Uri += "//" + eventHost + "/ClientEventsWS";

  console.log("Connecting to server for client events using Websocket.");

  ClearReconnectTimer();

  if (PingTimer)
  {
    window.clearInterval(PingTimer);
    PingTimer = null;
  }

  if (EventSocket)
  {
    try
    {
      EventSocket.close(1000, "Reconnecting.");
    }
    catch (e)
    {
      // Ignore
    }
    EventSocket = null;
  }

  EventSocket = new WebSocket(Uri, ["ls"]);

  EventSocket.onopen = async function ()
  {

    console.log("Websocket opened. Registring Tab for client events: " + TabID);

    EventSocket.send(JSON.stringify({
      "cmd": "Register",
      "tabId": TabID,
      "location": window.location.href
    }));

    StartPingLoop();
  };

  window.onbeforeunload = function ()
  {
    console.log("Unloading page.");

    EventCheckingEnabled = false;

    if (PingTimer)
    {
      window.clearInterval(PingTimer);
      PingTimer = null;
    }

    if (EventSocket && EventSocket.readyState === WebSocket.OPEN)
    {
      console.log("Unregistering Tab.");

      EventSocket.send(JSON.stringify({
        "cmd": "Unregister"
      }));

      EventSocket.close(1000, "Page closed.");
      EventSocket = null;
    }
  };

  EventSocket.onmessage = async function (event)
  {


    var Event;
    var s = event.data;
    if (s === "" || s === null)
      return;

    try
    {
      Event = JSON.parse(s);
    }
    catch (e)
    {
      console.log(e);
      console.log(s);
    }

    EvaluateEvent(Event);
  };

  EventSocket.onerror = function ()
  {
    console.log("Connection error.");

    ClearPingTimer();

    if (EventSocket && EventSocket.readyState === WebSocket.OPEN)
      StartPingLoop();
    else
      ScheduleReconnect(TabID, 2000);
  };

  EventSocket.onclose = function ()
  {
    console.log("Connection closed.");

    ClearPingTimer();
    ScheduleReconnect(TabID, 2000);
  };
}

function ClearPingTimer()
{
  if (PingTimer)
  {
    window.clearInterval(PingTimer);
    PingTimer = null;
  }
}

function StartPingLoop()
{
  ClearPingTimer();

  PingTimer = window.setInterval(function ()
  {
    if (EventSocket && EventSocket.readyState === WebSocket.OPEN)
    {
      console.log("Ping");

      EventSocket.send(JSON.stringify({
        "cmd": "Ping"
      }));
    }
    else
      ClearPingTimer();
  }, 10000);
}

function ClearReconnectTimer()
{
  if (ReconnectTimer)
  {
    window.clearTimeout(ReconnectTimer);
    ReconnectTimer = null;
  }
}

function ScheduleReconnect(TabID, Delay)
{
  if (!EventCheckingEnabled || !EventsStarted)
    return;

  if (ReconnectTimer)
    return;

  ReconnectTimer = window.setTimeout(function ()
  {
    ReconnectTimer = null;

    if (!EventCheckingEnabled || !EventsStarted)
      return;

    console.log("Reconnecting websocket.");
    CheckEventsWS(TabID);
  }, Delay);
}

export function CheckEventsXHTTP(TabID)
{
  var xhttp = new XMLHttpRequest();
  xhttp.onreadystatechange = async function ()
  {
    if (xhttp.readyState === 4)
    {
      if (xhttp.status === 200)
      {
        var Events;
        var i, c;

        try
        {
          var s = xhttp.responseText;

          if (s && s !== "")
          {
            try
            {
              Events = JSON.parse(s);
            }
            catch (e)
            {
              console.log(e);
              console.log(s);
            }

            if (Events)
            {
              c = Events.length;
              for (i = 0; i < c; i++)
                EvaluateEvent(Events[i]);
            }
          }
        }
        finally
        {
          if (EventCheckingEnabled)
          {
            console.log("Ping");

            xhttp.open("POST", "/ClientEvents", true);
            xhttp.setRequestHeader("Content-Type", "text/plain");
            xhttp.setRequestHeader("X-TabID", TabID);
            xhttp.send(window.location.href);
          }
        }
      }
      else
      {
        ShowError(xhttp);

        if (EventCheckingEnabled)
        {
          window.setTimeout(function ()
          {
            console.log("Reconnecting");

            xhttp.open("POST", "/ClientEvents", true);
            xhttp.setRequestHeader("Content-Type", "text/plain");
            xhttp.setRequestHeader("X-TabID", TabID);
            xhttp.send(window.location.href);
          }, 5000);
        }
      }
      //eslint-disable-next-line
    };
    //eslint-disable-next-line
  };

  EventCheckingEnabled = true;

  console.log("Connecting to server for client events using XML/HTTP-Request.");

  xhttp.open("POST", "/ClientEvents", true);
  xhttp.setRequestHeader("Content-Type", "text/plain");
  xhttp.setRequestHeader("X-TabID", TabID);
  xhttp.send(window.location.href);
}

function EvaluateEvent(Event)
{
  if (Event && Event.type.match(/^[a-zA-Z0-9]+$/g))
  {
    try
    {
      console.log(Event.type);
      eventEmitter.emit(Event.type, Event.data);
    }
    catch (e)
    {
      console.log(e);
    }
  }
}

function CloseEvents()
{
  console.log("Stopping event reception.");
  EventCheckingEnabled = false;

  ClearReconnectTimer();

  if (PingTimer)
  {
    window.clearInterval(PingTimer);
    PingTimer = null;
  }

  if (EventSocket)
  {
    try
    {
      EventSocket.close(1000, "Client stopped.");
    }
    catch (e)
    {
      // Ignore
    }
    EventSocket = null;
  }
}

function ShowError(xhttp)
{
  console.log("Error received: " + xhttp.responseText);

  if (xhttp.responseText.length > 0)
    window.alert(xhttp.responseText);
}

function CreateGUID()
{
  function Segment()
  {
    return Math.floor((1 + Math.random()) * 0x10000).toString(16).substring(1);
  }

  return Segment() + Segment() + '-' + Segment() + '-' + Segment() + '-' + Segment() + '-' + Segment() + Segment() + Segment();
}

function NOP(Data)
{
}

async function ClearCacheAsync(Data)
{
  try
  {
    console.log("Clearing cache.");

    var Keys = await caches.keys();
    var Tasks = Keys.map(Key => caches.delete(Key));

    await Promise.all(Tasks);

    console.log("Cache has been cleared.");
  }
  catch (e)
  {
    console.log(e);
  }
}

function Reload(Data)
{
  ClearReloadTimer();
  window.location.reload(false);
}

function ClearReloadTimer()
{
  if (ReloadTimer)
  {
    window.clearTimeout(ReloadTimer);
    ReloadTimer = null;
  }
}

function SetReloadTimer()
{
  ClearReloadTimer();
  ReloadTimer = window.setTimeout(async function ()
  {
    await ClearCacheAsync();
    Reload(null);
  }, 3000);
}

function OpenUrl(Url)
{
  window.open(Url, "_blank");
}

function EndsWith(String, Suffix)
{
  var c = String.length;
  var d = Suffix.length;

  if (c < d)
    return false;

  return String.substring(c - d, c) === Suffix;
}

function CheckServerInstance(ID)
{
  if (ServerID === "")
    ServerID = ID;
  else if (ServerID !== ID)
    Reload(null);
}

function POST(Content, Resource)
{
  if (Resource === undefined)
    Resource = window.location.href;

  var xhttp = new XMLHttpRequest();
  xhttp.onreadystatechange = function ()
  {
    if (xhttp.readyState === 4)
    {
      if (xhttp.status === 200)
      {
        var s = xhttp.responseText;
        var i = s.indexOf("<body>");
        var j = s.indexOf("</body>");

        if (i >= 0 && j >= i)
        {
          s = s.substring(i + 6, j);
          document.body.innerHTML = s;
        }
      }
      else
        ShowError(xhttp);
      //eslint-disable-next-line
    };
    //eslint-disable-next-line
  };

  xhttp.open("POST", Resource, true);
  xhttp.setRequestHeader("Content-Type", "application/json");
  xhttp.send(JSON.stringify({ "tab": currentTabId, "data": Content }));
}

function LoadContent(Id)
{
  if (ContentQueue === null)
  {
    ContentQueue = [];

    var xhttp = new XMLHttpRequest();
    xhttp.onreadystatechange = function ()
    {
      if (xhttp.readyState === 4)
      {
        if (xhttp.status === 200)
        {
          console.log("Received asynchronous content " + Id);

          var Div = document.getElementById("id" + Id);
          if (Div)
            SetDynamicHtml(Div, xhttp.responseText);

          if (xhttp.getResponseHeader("X-More") === "1")
          {
            console.log("Loading more asynchronous content from " + Id);
            xhttp.open("GET", "/ClientEvents/" + Id, true);
            xhttp.send();
            return;
          }
        }
        else
        {
          console.log("Unable to receive asynchronous content " + Id);
          ShowError(xhttp);
        }

        if (ContentQueue.length === 0)
        {
          console.log("Loading of asynchronous content completed.");
          ContentQueue = null;
        }
        else
        {
          Id = ContentQueue.shift();
          console.log("Loading asynchronous content " + Id);
          xhttp.open("GET", "/ClientEvents/" + Id, true);
          xhttp.send();
        }
        //eslint-disable-next-line
      };
      //eslint-disable-next-line
    };

    console.log("Loading asynchronous content " + Id);
    xhttp.open("GET", "/ClientEvents/" + Id, true);
    xhttp.send();
  }
  else
  {
    console.log("Queueing loading of asynchronous content " + Id);
    ContentQueue.push(Id);
  }
}

function SetDynamicHtml(ParentElement, Html)
{
  var Script = [];
  var HtmlLower = Html.toLocaleLowerCase();
  var i = HtmlLower.indexOf("<script");

  while (i >= 0)
  {
    var j = HtmlLower.indexOf("</script>", i + 7);
    if (j < 0)
      break;

    Script.push(Html.substring(i + 8, j));

    Html = Html.substring(0, i) + Html.substring(j + 9);
    HtmlLower = HtmlLower.substring(0, i) + HtmlLower.substring(j + 9);

    i = HtmlLower.indexOf("<script", i);
  }

  ParentElement.innerHTML = Html;

  var c = Script.length;

  for (i = 0; i < c; i++)
  {
    try
    {
      eval(Script[i]);
    }
    catch (e)
    {
      console.log(e);
    }
  }
}

var ContentQueue = null;
export var signedStatus = false;
var ServerID = "";
var EventCheckingEnabled = false;
var ReloadTimer = null;
var EventSocket = null;
var PingTimer = null;
var ReconnectTimer = null;
var EventsStarted = false;
var currentTabId = null;
var ServerEventHandlersRegistered = false;

function getOrCreateTabId()
{
  try
  {
    if (window.name.length === 36)
      return window.name;
    return window.name = CreateGUID();
  }
  catch (e)
  {
    return CreateGUID();
  }
}

export function getTabId()
{
  return currentTabId;
}

export function startEvents(tabId)
{
  if (EventsStarted)
    return;

  EventsStarted = true;
  EventCheckingEnabled = true;

  currentTabId = tabId || getOrCreateTabId();
  CheckEvents(currentTabId);
}

export function stopEvents()
{
  if (!EventsStarted)
    return;

  EventsStarted = false;
  CloseEvents();
}

const ServerEventHandlers = new Map([
  ["paymentComplete", paymentComplete],
  ["signStatus", signStatus],
  ["printthing", printthing],
  ["NOP", NOP],
  ["ClearCacheAsync", ClearCacheAsync],
  ["Reload", Reload],
  ["SetReloadTimer", SetReloadTimer],
  ["OpenUrl", OpenUrl],
  ["LoadContent", LoadContent],
  ["POST", POST],
  ["CheckServerInstance", CheckServerInstance],
]);

function RegisterServerEventHandlers()
{
  if (ServerEventHandlersRegistered)
    return;

  ServerEventHandlersRegistered = true;

  ServerEventHandlers.forEach((handler, eventName) =>
  {
    eventEmitter.on(eventName, handler);
  });
}

RegisterServerEventHandlers();

const EventsContext = createContext({
  eventEmitter,
  TabID: null,
  signedStatus,
  startEvents,
  stopEvents,
});

export function EventsProvider({ children }) {
  const [tabId] = useState(() => getOrCreateTabId());

  useEffect(() => {
    startEvents(tabId);
    return () => {
      stopEvents();
    };
  }, [tabId]);

  const value = useMemo(
    () => ({
      eventEmitter,
      TabID: tabId,
      signedStatus,
      startEvents,
      stopEvents,
    }),
    [tabId]
  );

  return (
    <EventsContext.Provider value={value}>
      {children}
    </EventsContext.Provider>
  );
}

export function useEvents()
{
  return useContext(EventsContext);
}

export default EventsContext;
